// Reads a top-level or nested `key: value` line from a YAML metadata string.
// Returns the trimmed value, or undefined when the key is missing.
export function getMetadataValue(metadata, key) {
  const match = metadata?.match(
    new RegExp(`^\\s*${key}:[ \\t]*(.*?)\\s*$`, 'm')
  );

  return match?.[1];
}

export function getAdvertisementData(metadata) {
  const name = getMetadataValue(metadata, 'advertorialName');
  const url = getMetadataValue(metadata, 'advertorialUrl');

  if (name && url) return [name, url];
}

export function getContentReference(metadata) {
  const referenceData = metadata && metadata.match(/\[.+\)/);

  return (
    referenceData &&
    referenceData[0]
      .split(', ')
      .map((item) => {
        const data = item.match(/\[(.+?)]\((.+?)\)/);

        if (data)
          return {
            title: data[1],
            link: data[2]
          };
      })
      .filter(Boolean)
  );
}
